<div [class]="getIconSizeClasses()" #iconContainer></div>
